export enum StatusNda {
  waiting_approval = 0,
  approved = 1,
  disapproved = 2
}
